import { useMemo } from 'react';
import { useAppSelector } from '../store';

const useAppModalsStatus = () => {
  const {
    userData,
  } = useAppSelector(({ profile }) => profile);
  const {
    chestsHistory, chestsHistoryLoading,
  } = useAppSelector(({ chests }) => chests);
  const { activeRewards } = useAppSelector(({ leaderboard }) => leaderboard);
  const { questsList } = useAppSelector(({ quests }) => quests);
  const appChests = (chestsHistory || []).filter((chest) => chest.obtained_by !== 'tutorial');
  const tutorialChests = (chestsHistory || []).filter((chest) => chest.obtained_by === 'tutorial');
  const showTutorialModal = useMemo(
    () => {
      if (!questsList?.tutorial?.[0]?.progress) {
        return true;
      }
      if (!['canceled', 'done'].includes(questsList?.tutorial[0].progress?.status || '')) {
        return true;
      }
      if (questsList?.tutorial?.[0].progress?.status === 'done' && (tutorialChests.length && tutorialChests?.[0]?.status !== 'claimed')) {
        return true;
      }

      return false;
    },
    [questsList, tutorialChests, chestsHistory],
  );
  const isDailyRewardAvailable = useMemo(
    () => {
      if (!userData?.user_schedule_task) {
        return true;
      }

      const availableAtDate = new Date(userData.user_schedule_task.click_time);

      availableAtDate.setDate(availableAtDate.getDate() + 1);

      return availableAtDate.toISOString() < new Date().toISOString();
    },
    [userData],
  );
  const isLeagueRewardAvailable = useMemo(
    () => !!activeRewards?.length,
    [userData, activeRewards],
  );

  return {
    dailyReward: isDailyRewardAvailable,
    chestHistory: !!appChests?.length,
    leagues: isLeagueRewardAvailable,
    chestsHistoryLoading,
    tutorial: showTutorialModal,
  };
};

export default useAppModalsStatus;
